import { Box, BoxProps } from '@amzn/ring-ui-react-components';

export const PostingContent = (props: BoxProps) => (
  <Box
    width={{ base: 'full', m: '40vw' }}
    maxWidth="100%"
    position="relative"
    {...props}
  />
);
